import React, { createContext, useContext } from "react";

// USA program was removed. The app is now single-country (El Salvador only).
// This module is kept so all `useCountry()` call sites keep working without
// touching them — every consumer now sees a hard-coded SV context.
//
// The `cantidad_us` / `availability` fields in the products DB are preserved
// intact (business decision). Only the buyer-facing US experience is gone.

const CountryCtx = createContext(null);
const COUNTRIES = {
    SV: { code: "SV", label: "El Salvador", flag: "🇸🇻", currency: "USD" },
};

export function CountryProvider({ children }) {
    // Static: no state, no localStorage, no /auth/me sync. Country is always SV.
    // `setCountry` is a no-op so existing callers don't blow up.
    const value = {
        country: "SV",
        setCountry: async () => {},
        hydrated: true,
        info: COUNTRIES.SV,
        COUNTRIES,
    };
    // Mark <body> so country-scoped CSS keeps working.
    if (typeof document !== "undefined") {
        document.body.setAttribute("data-country", "SV");
    }
    return <CountryCtx.Provider value={value}>{children}</CountryCtx.Provider>;
}

export function useCountry() {
    const ctx = useContext(CountryCtx);
    if (!ctx) throw new Error("useCountry must be used within CountryProvider");
    return ctx;
}
